<template>
    <div>
        <!-- 左按钮 -->
        <button class="switch-btn left-btn" @click="prev" :disabled="mainProjectIndex === 0" v-if="mainProjects.length>1">
            ←
        </button>
        <!-- 右按钮 -->
        <button class="switch-btn right-btn" @click="next" :disabled="mainProjectIndex === mainProjects.length - 1" v-if="mainProjects.length>1">
            →
        </button>

        <!-- 西北农林项目 -->
        <div class="content" v-if="mainProjectIndex==0">
            <div class="title">
                <div class="icon"> </div>
                <h1>西北农林项目</h1>
            </div>
            <!-- <div class="img-container">
                <p class="p-right" style="margin-top: 6em;width:18em;">
                    西北农林科技大学坐落于陕西杨凌示范区，是中华人民共和国教育部直属的全国重点大学，是中国西北地区现代高等农业教育的发源地，也是全国农林水学科最为齐备的高等农业院校，是国家“双一流”建设高校。</p>
                <img src="../../../../../assets/img/case/jiaoyu/jiaoyu_xibeinonglin.png"></img>
            </div> -->
            <p><img src="../../../../../assets/img/case/jiaoyu/jiaoyu_xibeinonglin.png" class="company-img"></img></p>
            <p>
                该校化学与合成生物学大楼项目总建筑面积为54144.29平方米，由多个功能单元有机组成，项目整体布局科学合理，通风系统设计先进，全面满足高水平科研与现代化教学的多样化需求。项目积极响应国家“双一流”学科建设战略，旨在强化合成生物学、生物化学等前沿领域的科研与教学能力，推动农业与生命科学领域的关键技术突破。通过整合化学、生物学、农学等多学科资源，大楼将重点聚焦合成生物学、绿色化学、生物医药等前沿研究方向。
            </p>
            <p style="text-align: center;"><img src="../../../../../assets/img/case/jiaoyu/jiaoyu_xibeinonglin_1.png"
                    style="width: 60%;margin:2em auto;"></img></p>
        </div>
        <foot-img-carousel type="jiaoyu" :projects="otherProjects" @change="showProjectDetail"></foot-img-carousel>
    </div>
</template>

<script>
import footImgCarousel from './footImgCarousel.vue';
export default{
    components:{
        footImgCarousel
    },
    data(){
        return {
            mainProjectIndex:0,
            mainProjects: [
                {
                    cover: "xibeinonglin",
                    title: "西北农林项目",
                    hasDetail:true
                }                
            ],
            otherProjects:[
                {
                    cover: "beijingdaxue",
                    title: "北京大学计算机控制中心机房控制系统",
                    hasDetail:false
                },
                {
                    cover: "beijingyoudian",
                    title: "北京邮电大学超级计算中心机房控制系统",
                    hasDetail:false
                },
                {
                    cover: "shanxishifan",
                    title: "陕西师范大学博物馆博物馆智能化系统",
                    hasDetail:false
                },
                {
                    cover: "gaoxinyizhong",
                    title: "西安高新第一中学智能化系统",
                    hasDetail:false
                },
                {
                    cover: "fengdong",
                    title: "沣东第一初级中学智能化系统",
                    hasDetail:false
                },
                {
                    cover: "wuyi",
                    title: "五邑大学医药大数据中心机房自控系统",
                    hasDetail:false
                },
                {
                    cover: "disijunyidaxue",
                    title: "第四军医大学动物实验中心自控系统",
                },
                {
                    cover: "gansuzhongyiyao",
                    title: "甘肃中医药大学动物实验中心自控系统",
                },
                {
                    cover: "xianjiaoda",
                    title: "西安交通大学医学院动物实验中心自控系统",
                }
            ]
        }
    },
    methods:{
        showProjectDetail(index) {
            this.mainProjectIndex =index
        },
        prev() {
            if (this.mainProjectIndex > 0) this.mainProjectIndex--;
        },
        next() {
            if (this.mainProjectIndex < this.mainProjects.length - 1) this.mainProjectIndex++;
        }
    }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/case.less';
</style>